<template>
  <v-dialog scrollable v-model="dialog" max-width="650px">
    <v-card
      class="py-2 strategio-card-container"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >{{isNew ? 'Crear distribuidor' : 'Editar distribuidor'}}</v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <v-text-field
          label="Distribuidor"
          v-model="data.distributorName"
          :rules="[validateDistributor(), validateForm()]"
          required
          clearable
        ></v-text-field>
        <v-text-field
          label="Nombre de archivo remoto"
          v-model="data.remoteFileName"
          clearable
        ></v-text-field>
        <v-text-field
          label="Código de distribuidor (1)"
          v-model="data.distributorCode1"
          hint="Este código corresponde al identificador largo de la distribuidora"
          clearable
        ></v-text-field>
        <v-text-field
          label="Código de distribuidor (2)"
          v-model="data.distributorCode2"
          hint="Este código corresponde al identificador corto de la distribuidora"
          clearable
        ></v-text-field>
        <v-text-field
          label="Código de distribuidor (3)"
          v-model="data.distributorCode3"
          hint=""
          clearable
        ></v-text-field>
        <v-text-field
          label="Correo de contacto"
          v-model="data.contactMail"
          hint=""
          clearable
        ></v-text-field>
        <v-text-field
          label="Url de reporte de inconsistencias"
          v-model="data.inconsistenciesFileUrl"
          hint=""
          clearable
        ></v-text-field>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <v-btn
          small depressed rounded dark
          class="strategio-dialog-button error"
          @click.native="dialog = false"
        >Cerrar</v-btn>
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          style="background-color:#61B965;color:white;"
          :loading="isLoading"
          :disabled="!isValidForm"
          @click.native="sendNewData()"
        >Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'

import supervisorStorage from '../../storage/supervisorStorage'

export default {
  name: 'distributor-form-dialog',
  data () {
    return {
      dialog: false,
      distributorID: 0,
      data: {
        remoteFileName: '',
        distributorName: '',
        distributorCode1: '',
        distributorCode2: '',
        distributorCode3: '',
        contactMail: '',
        inconsistenciesFileUrl: '',

        lastLog: [],
        canReadJsonLog: false,
        lastLogDate: '',
        isLastLogOutdated: true,
        logDateFromNow: '',

        salesTableName: '',
        salesLastUpdate: '',
        isSalesLastUpdatedOutdated: true,
        salesLastUpdateFromNow: '',

        salesMaxDate: '',
        isSalesMaxDateOutdated: true,
        salesMaxDateFromNow: '',

        inconsistenciesCounter: 0
      },
      isValidForm: false,
      isNew: false,
      isLoading: false
    }
  },
  created () {
    eventBus.$off('open-distributor-form')
    eventBus.$on('open-distributor-form', (item) => {
      this.isNew = !('distributorID' in item)
      this.distributorID = item.distributorID || 0
      this.data = {
        remoteFileName: item.remoteFileName || '',
        distributorName: item.distributorName || '',
        distributorCode1: item.distributorCode1 || '',
        distributorCode2: item.distributorCode2 || '',
        distributorCode3: item.distributorCode3 || '',
        contactMail: item.contactMail || '',
        inconsistenciesFileUrl: item.inconsistenciesFileUrl || '',

        lastLog: item.lastLog || [],
        canReadJsonLog: item.canReadJsonLog || false,
        lastLogDate: item.lastLogDate || '',
        isLastLogOutdated: item.isLastLogOutdated || true,
        logDateFromNow: item.logDateFromNow || '',

        salesTableName: item.salesTableName || '',
        salesLastUpdate: item.salesLastUpdate || '',
        isSalesLastUpdatedOutdated: item.isSalesLastUpdatedOutdated || true,
        salesLastUpdateFromNow: item.salesLastUpdateFromNow || '',

        salesMaxDate: item.salesMaxDate || '',
        isSalesMaxDateOutdated: item.isSalesMaxDateOutdated || true,
        salesMaxDateFromNow: item.salesMaxDateFromNow || '',

        inconsistenciesCounter: item.inconsistenciesCounter || 0
      }
      this.dialog = true
    })
  },
  methods: {
    sendNewData () {
      if (!this.isValidForm) {
        return
      }
      this.isLoading = true
      console.warn('loading')
      if (this.isNew) {
        supervisorStorage.addDistributor({
          data: {
            item: {
              distributorID: this.distributorID,
              ...this.data
            }
          },
          onSuccess: () => {
            this.dialog = false
          },
          onError: (error) => {
            console.warn('error creando distribudor: ', error)
            eventBus.$emit('open-custom-snack-bar', {message: 'No se ha podido crear el distribuidor', itsOk: false})
          },
          finally: () => {
            this.isLoading = false
          }
        })
      } else {
        supervisorStorage.editDistributor({
          data: {
            item: {
              distributorID: this.distributorID,
              ...this.data
            }
          },
          onSuccess: () => {
            this.dialog = false
          },
          onError: (error) => {
            console.warn('error editando distribudor: ', error)
            eventBus.$emit('open-custom-snack-bar', {message: 'No se ha podido editar el distribuidor', itsOk: false})
          },
          finally: () => {
            this.isLoading = false
          }
        })
      }
    },
    validateDistributor () {
      if (this.data.distributorName && this.data.distributorName.trim() !== '') {
        return true
      }
      return 'Este campo es obligatorio'
    },
    validateForm () {
      const isValidDistributor = (this.data.distributorName && this.data.distributorName.trim() !== '')
      this.isValidForm = isValidDistributor
      return this.isValidForm
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/distributor-form-dialog.vue